import { render } from "./SunIcon.vue?vue&type=template&id=14cf6864"
import script from "./SunIcon.vue?vue&type=script&lang=js"
export * from "./SunIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__